<template>
  <v-dialog @click:outside="closeUploadSutitle" v-model="dialogModel" width="360px">
    <!-- <template v-slot:activator="{ on, attrs }">
      <span v-on="on" v-bind="attrs">
        <v-btn v-bind="attrs" v-on="on">SubTitles</v-btn>
      </span>
    </template> -->
    <v-card
      :class="dragover ? 'container-sub-title-upload-active pa-7' : 'container-sub-title-upload pa-7'"
      color="#21343b"
      width="auto"
    >
      <v-card-text class="pa-0">
        <p class="sub-title-upload-title">{{ $t('subTitleUploadTitle') }}</p>
        <p class="sub-title-upload-sub-title mb-2">{{ $t('selectSubTitleFileTitle') }}</p>
        <v-card
          @drop.prevent="onDrop($event)"
          @dragover.prevent="dragover = true"
          @dragenter.prevent="dragover = true"
          @dragleave.prevent="dragover = false"
          align-self="center"
          class="container-sub-title-upload py-10"
          color="#1a272e"
        >
          <v-row v-if="isShowUploadState" class="d-flex flex-column flex-nowrap" dense align="center" justify="center">
            <p class="sub-title-upload-content-title mb-1">{{ $t('fileUploadContent') }}</p>
            <p class="sub-title-upload-content mb-1">{{ $t('subTitleUploadContent') }}</p>
            <p class="sub-title-upload-content">- {{ $t('or') }} -</p>

            <v-btn tag="label" color="#31434f" for="uploader-input" class="uploader-input text--white">
              {{ $t('fileUploadBtn') }}
            </v-btn>
            <p v-if="isWrongFile" class="sub-title-upload-failed-content mt-5">{{ $t('fileUploadFailed') }}</p>
          </v-row>
          <v-row
            v-else-if="isCheckingLoading"
            class="d-flex flex-column flex-nowrap"
            dense
            align="center"
            justify="center"
          >
            <p class="sub-title-upload-content">{{ $t('subTitleUploadChecking') }}</p>
            <v-progress-circular indeterminate :size="50" color="primary"></v-progress-circular>
          </v-row>
          <v-row align="center" class="px-3" no-gutters v-else>
            <v-col>
              <span class="sub-title-upload-content-title">{{ uploadedFiles[0].name }}</span>
            </v-col>
            <v-col class="ml-2" cols="auto">
              <span class="sub-title-upload-content-title">{{ (uploadedFiles[0].size / 1024).toFixed(2) }}KB</span>
            </v-col>
            <v-col class="ml-2 mt-1" cols="auto">
              <span
                @click="removeFile"
                class="material-icons-round"
                style="color: #ccc; font-size: 28px; cursor: pointer"
                translate="no"
              >
                cancel
              </span>
            </v-col>
          </v-row>
          <input accept=".vtt,.srt" type="file" id="uploader-input" name="uploader-input" @change="onDrop" />
        </v-card>

        <p class="sub-title-upload-sub-title mt-4">{{ $t('selectSubTitleLanguageTitle') }}</p>
        <v-select
          id="language"
          hide-details
          dark
          v-model="language"
          :items="languageList"
          item-text="country"
          item-value="code"
          dense
          outlined
          return-object
          single-line
          :placeholder="$t('selectSubTitleLanguageTitle')"
        >
          <!-- <template slot="selection" slot-scope="data">{{ $t(`language.${data.item}`) }}</template>
          <template slot="item" slot-scope="data">{{ $t(`language.${data.item}`) }}</template> -->
        </v-select>
      </v-card-text>

      <v-row class="mt-4" no-gutters align="center" justify="center">
        <v-col align="center" no-gutters>
          <v-btn block color="#96a7af" @click="closeUploadSutitle">
            {{ $t('cancel') }}
          </v-btn>
        </v-col>
        <v-col class="ml-2" align="center" no-gutters>
          <v-btn
            :loading="isUploadLoading"
            :disabled="!isAvailableUpload || isCheckingLoading"
            block
            color="#27cd8b"
            @click="uploadSubtitle"
          >
            {{ $t('upload') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import Toast from '@/views/meeting/component/Toast'
import { createSubtitle } from '@/services/clipApi'
import { setFileUpload, setInvalidCache } from '@/services/api'
import { mapState } from 'vuex'
import toWebVTT from 'srt-webvtt'
import value from '@/common/value'

export default {
  name: 'UploadVideoDialog',
  created() {},
  props: ['isUploadSubtitleDialog'],
  data() {
    return {
      dragover: false,
      uploadedFiles: [],
      isWrongFile: false,
      isUploadLoading: false,
      isCheckingLoading: false,
      language: null,
      maximumFileSize: 5 * 1024 * 1024, // 5MB 제한
      blob: null,
      resultClip: null,
      languageList: value.language,
      dialogModel: false,
    }
  },
  methods: {
    closeUploadSutitle() {
      // Remove all the uploaded files
      this.uploadedFiles = []
      // Close the dialog box
      //   this.$emit('closeUploadSutitle')
      this.$emit('close')
      this.dialogModel = false
    },
    finishUploadSubtitle() {
      // Remove all the uploaded files
      this.uploadedFiles = []
      // Close the dialog box
      //   this.$emit('closeUploadSutitle')
      this.$emit('finishUploadSubtitle', this.language)
      this.dialogModel = false
      this.totalSectionList[this.sectionIndex].clipList[this.clipIndex].subTitleData = this.resultClip.subTitleData
      this.$store.dispatch('setCurrentClip', this.totalSectionList[this.sectionIndex].clipList[this.clipIndex])
    },
    removeFile() {
      // Find the index of the
      // const index = this.uploadedFiles.findIndex((file) => file.name === fileName)
      // If file is in uploaded files remove it
      // if (index > -1) this.uploadedFiles.splice(index, 1)
      if (this.uploadedFiles && this.uploadedFiles.length > 0) this.uploadedFiles = []
    },
    onDrop(e) {
      this.isCheckingLoading = true
      let files = e.target.files || e.dataTransfer.files

      // 파일이 선택되지 않았을 경우
      if (!files.length) return
      // 파일이 여러개 선택되었을 경우
      else if (files.length > 1) {
        // notify(this, 'Error', this.$t('onlyOneVideo'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('onlyOneVideo'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        return
      }

      this.isWrongFile = false
      this.dragover = false

      const file = files[0]

      let isSrt =
        file &&
        (file.type === undefined || file.type === null || file.type === '') &&
        file.name.split('.').pop() === 'srt'
      let mimeType = file.type
      let fileExtention = mimeType.split('/').pop()
      if (!isSrt && fileExtention !== 'vtt') {
        // notify(this, 'Error', this.$t('onlySrtFile'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('onlySrtFile'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        return
      }
      if (file.size > this.maximumFileSize) {
        // notify(this, 'Error', this.$t('fileSizeError'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('fileSizeError'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        return
      }
      //   let convertedFile = this.srtToWebVtt(files[0])
      if (this.uploadedFiles.length > 0) this.uploadedFiles = []
      this.uploadedFiles = files
      this.createSrtURI(isSrt)

      // this.changeFile(e)
    },
    async createSrtURI(isSrt) {
      // Srt 일 경우 Conver Library 에서 처리
      let error
      try {
        if (isSrt) {
          let blobUrl = await toWebVTT(this.uploadedFiles[0])
          this.blob = await fetch(blobUrl).then((r) => r.blob())
        } // Vtt 파일일 경우
        else {
          var reader = new FileReader()
          reader.readAsArrayBuffer(this.uploadedFiles[0])
          reader.onload = (e) => {
            this.blob = new Blob([e.target.result], {
              type: 'text/vtt',
            })
          }
        }
      } catch (err) {
        error = err
      } finally {
        this.isCheckingLoading = false
        if (error === undefined || error === null) {
          // 자막 업데이트 완료되면 S3 에 파일 업로드
        } else {
          // notify(this, 'Error', this.$t('setSubTitleFail'), 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('setSubTitleFail'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
          console.log(error.message)
        }
      }
    },
    /**
     * File Check 후 Upload 버튼
     */
    async uploadSubtitle() {
      let error
      try {
        this.isUploadLoading = true
        this.resultClip = await createSubtitle(this, this.mtInfo.mtId, this.currentClip.clipId, this.language)
      } catch (err) {
        error = err
      } finally {
        if (error === undefined || error === null) {
          // 자막 업데이트 완료되면 S3 에 파일 업로드
          this.setClipUpload()
        } else {
          this.isUploadLoading = false
          if (error.message === 'AlreadyExist') {
            // notify(this, 'Error', this.$t('subtitleAlreadyExist'), 'error')
            const content = {
              component: Toast,
              props: {
                msg: this.$t('subtitleAlreadyExist'),
                // submsg: '',
              },
            }
            this.$toast.error(content)
          } else {
            // notify(this, 'Error', this.$t('setSubTitleFail'), 'error')
            const content = {
              component: Toast,
              props: {
                msg: this.$t('setSubTitleFail'),
                // submsg: '',
              },
            }
            this.$toast.error(content)
          }
        }
      }
    },
    /**
     * 자막 S3 업로드
     */
    async setClipUpload() {
      let result
      let err
      let ctx = this
      let subtId = `${this.language.code}:${this.currentClip.clipId}`
      try {
        let parallellUploads = await setFileUpload(this, this.blob, 'clip', this.wsInfo.wsId, subtId)
        parallellUploads.on('httpUploadProgress', (progress) => {
          ctx.progressValue = 10 + Math.floor((100 / (progress.total / progress.loaded)) * 0.9)
        })
        result = await parallellUploads.done()
      } catch (e) {
        err = e
        console.log('subTitle upload failed  : ', err)
      } finally {
        this.isUploadLoading = false
        // 실패일 경우
        if ((result && result !== null && result.$metadata.httpStatusCode !== 200) || err !== undefined) {
          // notify(this, 'Error', this.$t('setSubTitleFail'), 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('setSubTitleFail'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        } else {
          // notify(this, 'Success', this.$t('uploadSubtitleSuccess'), 'success')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('uploadSubtitleSuccess'),
              // submsg: '',
            },
          }
          this.$toast.success(content)
          this.language.subtId = subtId
          this.finishUploadSubtitle()
        }

        // Cloud Front 캐시 삭제
        await setInvalidCache(this, `/clip/${this.wsInfo.wsId}/${subtId}.vtt`)
      }
    },
  },
  watch: {
    isUploadSubtitleDialog(val) {
      this.dialogModel = val
    },
  },
  computed: {
    ...mapState({
      currentClip: (state) => state.clip.currentClip,
      wsInfo: (state) => state.auth.selectedWsInfo,
      mtInfo: (state) => state.auth.currentMt,
      totalSectionList: (state) => state.clip.totalSectionList,
      sectionIndex: (state) => state.clip.sectionIndex,
      clipIndex: (state) => state.clip.clipIndex,
    }),
    isShowUploadState() {
      return !this.uploadedFiles || this.uploadedFiles === null || this.uploadedFiles.length <= 0
    },
    isSelectedLanguage() {
      return this.language && this.language.code && this.language.code !== ''
    },
    isAvailableUpload() {
      return !this.isShowUploadState && !this.isCheckingLoading && this.isSelectedLanguage
    },
  },
}
</script>

<style scoped>
.container-sub-title-upload-active {
  border-radius: 10px;
  border: solid 5px #ff575f !important;
  /* outline: solid 10px #ff575f !important;
  z-index: 2000; */
}
.container-sub-title-upload {
  /* min-width: 360px; */
  border-radius: 10px;
}
.sub-title-upload-title {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
}
.sub-title-upload-sub-title {
  text-align: left;
  font-size: 14px;
  font-weight: bold;
  color: white;
}
.sub-title-upload-content-title {
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: white;
}
.sub-title-upload-content {
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #869399;
}
.sub-title-upload-failed-content {
  width: 250px !important;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #ff575f;
}
.btn-delete-follow-up {
  color: white;
  font-size: 14px;
  text-transform: none;
}

.container-sub-title-upload >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
.container-sub-title-upload-active >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}

.uploader-input {
  cursor: pointer;
}

#uploader-input {
  width: 0;
  height: 0;
  line-height: 0;
  font-size: 0;
  text-indent: -9999px;
}

.uploader-input img {
  display: block;
  width: calc(100% - 2px) !important;
  height: calc(100% - 2px) !important;
  object-fit: cover;
}
/* .container-v-btn >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
} */

.v-btn.v-btn--disabled.v-btn--has-bg {
  color: #fff !important;
  background-color: #96a7af !important;
}
</style>
